import React from 'react';
import TaskItem from './TaskItem';

export default function TaskList({
  tasks,
  loading,
  searchQuery,
  setSearchQuery,
  onToggle,
  onEdit,
  onDelete,
  onAddNew
}) {
  return (
    <div style={{ flex: 1 }}>
      {/* Search */}
      <div style={{
        backgroundColor: "var(--card-bg)",
        borderRadius: '6px',
        border: '1px solid var(--border)',
        padding: '10px',
        marginBottom: '12px'
      }}>
        <input
          type="text"
          placeholder={'🔍 Szukaj zadań...'}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            width: '100%',
            padding: '6px 10px',
            border: '1px solid var(--border)',
            borderRadius: '6px',
            backgroundColor: 'var(--card-bg)',
            color: 'var(--text)',
            fontSize: '12px',
            outline: 'none'
          }}
        />
      </div>

      {/* Tasks list */}
      <div>
        {loading ? (
          <div style={{
            textAlign: 'center',
            padding: '32px',
            color: 'var(--text-muted)',
            backgroundColor: "var(--card-bg)",
            borderRadius: '6px',
            border: '1px solid var(--border)'
          }}>
            <div style={{ fontSize: '24px', marginBottom: '8px' }}>{'⏳'}</div>
            Ładowanie...
          </div>
        ) : tasks.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '32px',
            backgroundColor: "var(--card-bg)",
            borderRadius: '6px',
            border: '1px solid var(--border)'
          }}>
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>{'✅'}</div>
            <p style={{ color: 'var(--text-muted)', marginBottom: '12px', fontSize: '13px' }}>Brak zadań w tej kategorii</p>
            <button
              onClick={onAddNew}
              style={{
                color: 'var(--info)',
                background: 'none',
                
                cursor: 'pointer',
                textDecoration: 'underline',
                fontSize: '12px'
              }}
            >
              Dodaj nowe zadanie
            </button>
          </div>
        ) : (
          <div style={{
            backgroundColor: "var(--card-bg)",
            borderRadius: '6px',
            border: '1px solid var(--border)',
            padding: '10px'
          }}>
            {tasks.map(task => (
              <TaskItem
                key={task.id}
                task={task}
                onToggle={onToggle}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
